export const getVendorTable = (builder) => ({
    getVendorTable: builder.mutation({
        query: ({ page, limit, start, end, vendor }) => {
            const token = JSON.parse(localStorage.getItem('TOKEN'))?.token || '';
            return {
                url: '/get_vendor_wallet_list',
                method: 'GET',
                params: { page, limit, start, end, vendor },
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                },
            };
        },
    }),
});